import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PLANNED_INDICATORS_ITEM: {},
  PLANNED_INDICATORS_LIST: [],
  PLANNED_INDICATORS_TABLE_DATA: [],
  PLANNED_INDICATORS_ARRAY_DATA: [],
  PLANNED_INDICATORS_TOTAL_ROWS: 0
}

export const getters = {
  GET_PLANNED_INDICATORS_ITEM: (state) => {
    return state.PLANNED_INDICATORS_ITEM;
  },
  GET_PLANNED_INDICATORS_LIST: (state) => {
    return state.PLANNED_INDICATORS_LIST;
  },
  GET_PLANNED_INDICATORS_TABLE_DATA: (state) => {
    return state.PLANNED_INDICATORS_TABLE_DATA;
  },
  GET_PLANNED_INDICATORS_ARRAY_DATA: (state) => {
    return state.PLANNED_INDICATORS_ARRAY_DATA;
  },
  GET_PLANNED_INDICATORS_TOTAL_ROWS: (state) => {
    return state.PLANNED_INDICATORS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_PLANNED_INDICATORS_ITEM(state, item) {
    state.PLANNED_INDICATORS_ITEM = item;
  },

  UPDATE_PLANNED_INDICATORS_LIST(state, list) {
    
    state.PLANNED_INDICATORS_LIST = list.data;

    state.PLANNED_INDICATORS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.PLANNED_INDICATORS_TABLE_DATA = [];
    state.PLANNED_INDICATORS_ARRAY_DATA = [];

    list.forEach(el => {

      state.PLANNED_INDICATORS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'comments'   : el.comments,        
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.PLANNED_INDICATORS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_PLANNED_INDICATORS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/planned/indicators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PLANNED_INDICATORS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_PLANNED_INDICATORS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/planned/indicators';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PLANNED_INDICATORS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_PLANNED_INDICATORS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/planned/indicators';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PLANNED_INDICATORS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/planned/indicators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PLANNED_INDICATORS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/planned/indicators/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}